/*start-with-an-example*/
/*core-maintained-examples*/
/*community-maintained-examples*/
/*use-a-community-example*/
/*options*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "create-turbo",
  "description": "快速从头开始设置新的 Turborepo 仓库。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "开始使用 Turborepo 最简单的方法是使用 create-turbo。使用此命令行工具快速开始构建新的 monorepo，所有设置均已为你设置好。"
  }, {
    "heading": "",
    "content": "¥The easiest way to get started with Turborepo is by using create-turbo. Use this CLI tool to quickly start building a new monorepo, with everything set up for you."
  }, {
    "heading": "从示例开始-start-with-an-example",
    "content": "¥Start with an example"
  }, {
    "heading": "从示例开始-start-with-an-example",
    "content": "社区精心挑选了一组示例，展示如何在 Turborepo 中使用常用工具和库。要使用其中一个示例引导你的 monorepo，请使用 --example 标志："
  }, {
    "heading": "从示例开始-start-with-an-example",
    "content": "¥The community curates a set of examples to showcase ways to use common tools and libraries with Turborepo. To bootstrap your monorepo with one of the examples, use the --example flag:"
  }, {
    "heading": "从示例开始-start-with-an-example",
    "content": "使用以下任意示例名称："
  }, {
    "heading": "从示例开始-start-with-an-example",
    "content": "¥Use any of the example's names below:"
  }, {
    "heading": "核心维护示例-core-maintained-examples",
    "content": "¥Core-maintained examples"
  }, {
    "heading": "核心维护示例-core-maintained-examples",
    "content": "以下示例由 Turborepo 核心团队维护。依赖会尽可能保持最新，并接受和处理这些示例的 GitHub Issue。"
  }, {
    "heading": "核心维护示例-core-maintained-examples",
    "content": "¥The following examples are maintained by the Turborepo core team. Dependencies are kept as up-to-date as possible and GitHub Issues are accepted and addressed for these examples."
  }, {
    "heading": "社区维护的示例-community-maintained-examples",
    "content": "¥Community-maintained examples"
  }, {
    "heading": "社区维护的示例-community-maintained-examples",
    "content": "社区精心挑选了一组示例，展示如何在 Turborepo 中使用常用工具和库。要使用其中一个示例引导你的 monorepo，请使用 --example 标志："
  }, {
    "heading": "社区维护的示例-community-maintained-examples",
    "content": "¥The community curates a set of examples to showcase ways to use common tools and libraries with Turborepo. To bootstrap your monorepo with one of the examples, use the --example flag:"
  }, {
    "heading": "使用社区示例-use-a-community-example",
    "content": "¥Use a community example"
  }, {
    "heading": "使用社区示例-use-a-community-example",
    "content": "你还可以使用 GitHub URL 来使用自定义启动器或示例。这对于使用你自己的自定义启动器或来自社区的示例非常有用。"
  }, {
    "heading": "使用社区示例-use-a-community-example",
    "content": "¥You can also use a custom starter or example by using a GitHub URL. This is useful for using your own custom starters or examples from the community."
  }, {
    "heading": "选项-options",
    "content": "¥Options"
  }],
  "headings": [{
    "id": "从示例开始-start-with-an-example",
    "content": "从示例开始 /*start-with-an-example*/"
  }, {
    "id": "核心维护示例-core-maintained-examples",
    "content": "核心维护示例 /*core-maintained-examples*/"
  }, {
    "id": "社区维护的示例-community-maintained-examples",
    "content": "社区维护的示例 /*community-maintained-examples*/"
  }, {
    "id": "使用社区示例-use-a-community-example",
    "content": "使用社区示例 /*use-a-community-example*/"
  }, {
    "id": "选项-options",
    "content": "选项 /*options*/"
  }]
};
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
import {ExamplesTable} from '#components/examples-table';
export const toc = [{
  depth: 2,
  url: "#从示例开始-start-with-an-example",
  title: _jsx(_Fragment, {
    children: "从示例开始 "
  })
}, {
  depth: 2,
  url: "#核心维护示例-core-maintained-examples",
  title: _jsx(_Fragment, {
    children: "核心维护示例 "
  })
}, {
  depth: 2,
  url: "#社区维护的示例-community-maintained-examples",
  title: _jsx(_Fragment, {
    children: "社区维护的示例 "
  })
}, {
  depth: 3,
  url: "#使用社区示例-use-a-community-example",
  title: _jsx(_Fragment, {
    children: "使用社区示例 "
  })
}, {
  depth: 2,
  url: "#选项-options",
  title: _jsx(_Fragment, {
    children: "选项 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["开始使用 Turborepo 最简单的方法是使用 ", _jsx(_components.code, {
        children: "create-turbo"
      }), "。使用此命令行工具快速开始构建新的 monorepo，所有设置均已为你设置好。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The easiest way to get started with Turborepo is by using ", _jsx(_components.code, {
        children: "create-turbo"
      }), ". Use this CLI tool to quickly start building a new monorepo, with everything set up for you."]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "从示例开始-start-with-an-example",
      children: "从示例开始 "
    }), "\n", _jsx(_components.p, {
      children: "¥Start with an example"
    }), "\n", _jsxs(_components.p, {
      children: ["社区精心挑选了一组示例，展示如何在 Turborepo 中使用常用工具和库。要使用其中一个示例引导你的 monorepo，请使用 ", _jsx(_components.code, {
        children: "--example"
      }), " 标志："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The community curates a set of examples to showcase ways to use common tools and libraries with Turborepo. To bootstrap your monorepo with one of the examples, use the ", _jsx(_components.code, {
        children: "--example"
      }), " flag:"]
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [example-name]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [example-name]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [example-name]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [example-name]"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "使用以下任意示例名称："
    }), "\n", _jsx(_components.p, {
      children: "¥Use any of the example's names below:"
    }), "\n", _jsx(_components.h2, {
      id: "核心维护示例-core-maintained-examples",
      children: "核心维护示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Core-maintained examples"
    }), "\n", _jsx(_components.p, {
      children: "以下示例由 Turborepo 核心团队维护。依赖会尽可能保持最新，并接受和处理这些示例的 GitHub Issue。"
    }), "\n", _jsx(_components.p, {
      children: "¥The following examples are maintained by the Turborepo core team. Dependencies are kept as up-to-date as possible and GitHub Issues are accepted and addressed for these examples."
    }), "\n", _jsx(ExamplesTable, {
      coreMaintained: true
    }), "\n", _jsx(_components.h2, {
      id: "社区维护的示例-community-maintained-examples",
      children: "社区维护的示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Community-maintained examples"
    }), "\n", _jsxs(_components.p, {
      children: ["社区精心挑选了一组示例，展示如何在 Turborepo 中使用常用工具和库。要使用其中一个示例引导你的 monorepo，请使用 ", _jsx(_components.code, {
        children: "--example"
      }), " 标志："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥The community curates a set of examples to showcase ways to use common tools and libraries with Turborepo. To bootstrap your monorepo with one of the examples, use the ", _jsx(_components.code, {
        children: "--example"
      }), " flag:"]
    }), "\n", _jsx(ExamplesTable, {}), "\n", _jsx(_components.h3, {
      id: "使用社区示例-use-a-community-example",
      children: "使用社区示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Use a community example"
    }), "\n", _jsx(_components.p, {
      children: "你还可以使用 GitHub URL 来使用自定义启动器或示例。这对于使用你自己的自定义启动器或来自社区的示例非常有用。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can also use a custom starter or example by using a GitHub URL. This is useful for using your own custom starters or examples from the community."
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [github-url]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [github-url]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [github-url]"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " create-turbo@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --example"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " [github-url]"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "选项-options",
      children: "选项 "
    }), "\n", _jsx(_components.p, {
      children: "¥Options"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "-m, --package-manager to use (choices: \"npm\", \"yarn\", \"pnpm\", \"bun\")"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "--skip-install: Do not run a package manager install after creating the project (Default: false)"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "--skip-transforms: Do not run any code transformation after creating the project (Default: false)"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "--turbo-version <version>: Use a specific version of turbo (default: latest)"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "-e, --example [name]|[github-url]: An example to bootstrap the app with. You can use an example name from the official Turborepo repo or a GitHub URL. The URL can use any branch and/or subdirectory"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "-p, --example-path <path-to-example>: In a rare case, your GitHub URL might contain a branch name with a slash (e.g. bug/fix-1) and the path to the example (e.g. foo/bar). In this case, you must specify the path to the example separately: --example-path foo/bar"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "-v, --version:  Output the current version"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {})
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              children: "-h, --help: Display help for command"
            })
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
